module.exports = __webpack_public_path__ + "bcf0f375c30473413830223fd63d6525.pdf";